
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { MapaPeligroState } from '@/store/modules/mapa-peligro/types'
import { Action, State } from 'vuex-class'
import PeligroColorBar from '@/components/PeligroColorBar.vue'
import DesktopFooter from '@/components/DesktopFooter.vue'
import { getEnvironments } from '@/environments'
import { MapaPeligroApi } from '@/domain/entities/Api'
const env = getEnvironments()

const MAPA_PELIGRO_MODULE = 'mapaPeligro'
const GOOGLE_MAPS_MODULE = 'googleMaps'

@Component({
  components: {
    PeligroColorBar,
    DesktopFooter
  }
})
export default class Peligro extends Vue {
  @State(MAPA_PELIGRO_MODULE) public mapaPeligro!: MapaPeligroState;
  @Prop()
  private mapa!: number[];
  @Action('getMapaPeligro', { namespace: MAPA_PELIGRO_MODULE })
  private getMapaPeligro: any
  @Action('deleteMapaPeligro', { namespace: MAPA_PELIGRO_MODULE })
  private deleteMapaPeligro: any
  @Action('setOverlayViews', { namespace: GOOGLE_MAPS_MODULE })
  private setOverlayViews: any
  @Action('setAutocomplete', { namespace: GOOGLE_MAPS_MODULE })
  private setAutocomplete: any
  @Action('setPosition', { namespace: GOOGLE_MAPS_MODULE })
  private setPosition: any
  private baseImageUrl: string = env.url.IMG

  async created () {
    const position = env.settings.PELIGRO.center
    const zoom = env.settings.PELIGRO.zoom
    this.setPosition({ position, zoom })

    await this.getMapaPeligro()
    this.onMapaChanged(this.mapa, [])
  }

  get colorbarMap () {
    // TODO: filtrar por primer mapa no toggle
    return this.mapaPeligro.mapasPeligro.filter((_peligro, index) =>
      index === Number(this.mapa[0]))[0]
  }

  get selectedMapas () {
    return this.mapaPeligro.mapasPeligro.filter((_peligro, index) =>
      this.mapa.filter((ele: number) => Number(ele) === index).length > 0
    )
  }

  formatBounds (ruta: string) {
    return (bound: any) => ({
      image: `${this.baseImageUrl}${ruta}/${bound.imagen}`,
      isShown: true,
      bounds: {
        south: bound.latlong[0][0],
        north: bound.latlong[1][0],
        west: bound.latlong[0][1],
        east: bound.latlong[1][1]
      }
    })
  }

  @Watch('mapa', { immediate: false })
  async onMapaChanged (val: number[], oldVal: number[]) {
    const mapasPeligro = this.selectedMapas
    if (mapasPeligro.length > 0 && val.join('') !== oldVal.join('')) {
      const boundsFormatted = mapasPeligro.map((mapa) => {
        return mapa.imagen_list.map(this.formatBounds(mapa.ruta))
      }).reduce((a, b) => [...a, ...b])
      this.setOverlayViews(boundsFormatted)
    }
  }

  mounted () {
    this.setAutocomplete({ shown: true })
  }

  async beforeDestroy () {
    await this.setAutocomplete({ shown: false })
    this.deleteMapaPeligro()
    this.setOverlayViews([])
  }
}
